import React from "react";
import { Link } from "react-router-dom";

const EventIconSvg = () => (
    <svg
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_478_793)">
        <path
          d="M4.66667 7H3.5C2.85658 7 2.33333 7.52325 2.33333 8.16667V9.33333C2.33333 9.97675 2.85658 10.5 3.5 10.5H4.66667C5.31008 10.5 5.83333 9.97675 5.83333 9.33333V8.16667C5.83333 7.52325 5.31008 7 4.66667 7ZM3.5 9.33333V8.16667H4.66667V9.33333H3.5ZM11.0833 1.16667H10.5V0.583333C10.5 0.261333 10.2392 0 9.91667 0C9.59408 0 9.33333 0.261333 9.33333 0.583333V1.16667H4.66667V0.583333C4.66667 0.261333 4.40592 0 4.08333 0C3.76075 0 3.5 0.261333 3.5 0.583333V1.16667H2.91667C1.30842 1.16667 0 2.47508 0 4.08333V11.0833C0 12.6916 1.30842 14 2.91667 14H11.0833C12.6916 14 14 12.6916 14 11.0833V4.08333C14 2.47508 12.6916 1.16667 11.0833 1.16667ZM2.91667 2.33333H11.0833C12.0482 2.33333 12.8333 3.1185 12.8333 4.08333V4.66667H1.16667V4.08333C1.16667 3.1185 1.95183 2.33333 2.91667 2.33333ZM11.0833 12.8333H2.91667C1.95183 12.8333 1.16667 12.0482 1.16667 11.0833V5.83333H12.8333V11.0833C12.8333 12.0482 12.0482 12.8333 11.0833 12.8333Z"
          fill="#6E727B"
        />
      </g>
      <defs>
        <clipPath id="clip0_478_793">
          <rect width="14" height="14" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );

const ChevronRight = () => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" aria-hidden="true">
    <path
      d="M6 12L10 8L6 4"
      stroke="#6E727B"
      strokeWidth="1.33333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const HallBookingHero = ({
  hero,
  showDetails = false,
  detailsTitle = "Mamangam Hall Booking Details",
}) => {
  const { title, description } = hero;

  return (
    <div className="inner-banner">
      <div className="container">
        <div className="row justify-content-center">
        <div className="col-lg-10 text-center mx-auto">

        <ul className="breadcrumps">
  <li className="crumb-pair">
    <Link to="/">
      <EventIconSvg />
      Events
    </Link>
    <ChevronRight />
  </li>

  {showDetails ? (
    <>
      <li className="crumb-pair">
        <span>{title}</span>
        <ChevronRight />
      </li>

      <li className="breadcrumps-current">
        {detailsTitle}
      </li>
    </>
  ) : (
    <li className="breadcrumps-current">{title}</li>
  )}
</ul>

            <p>{description}</p>

          </div>
        </div>
      </div>
    </div>
  );
};

export default HallBookingHero;
